import {useLocation, useOutlet} from "react-router-dom";
import {AnimatePresence, motion} from "framer-motion";
import {
  fastPageVariants,
  fastPageTransition,
} from "../Animation/PageTransition";

interface FastAnimatedOutletProps {
  className?: string;
}

const FastAnimatedOutlet = ({className = ""}: FastAnimatedOutletProps) => {
  const location = useLocation();
  const outlet = useOutlet();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        initial="initial"
        animate="in"
        exit="out"
        variants={fastPageVariants}
        transition={fastPageTransition}
        className={`page-transition ${className}`}
      >
        {outlet}
      </motion.div>
    </AnimatePresence>
  );
};

export default FastAnimatedOutlet;
